type DataCardProps = {
  className?: string;
  header?: string;
  children?: React.ReactNode;
};
export const DataCard = (props: DataCardProps) => {
  const extraClass = props.className || "";
  return (
    <>
      <section className={`data-card ${extraClass}`.trim()}>
        {props.header && (
          <header className="data-card-header" role="heading" aria-level={1}>
            <span className="zb-heading2 data-card-header-title">
              {props.header}
            </span>
          </header>
        )}

        <div className="data-card-body">{props.children}</div>
      </section>
    </>
  );
};
